import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const Main=()=>(import('../pages/main.vue'))//登陆后主页
const Login=()=>(import('../pages/login.vue'))//登陆
const NotFound=()=>(import('../pages/notFound.vue'))//没找到页面
const ForgetPwd=()=>(import('../pages/forgetPwd.vue'))//忘记密码
const ActivationAccount=()=>(import('../pages/activationAccount.vue'))//激活账号
const ResetPwd=()=>(import('../pages/resetPwd.vue'))//重制密码
const Signup=()=>(import('../pages/signup.vue'))// 登陆
const DenyAccess=()=>(import('../pages/denyAccess.vue'));//没用权限页面
const Step=()=>(import('../pages/step/stepGuide.vue'));//向导页
const Version=()=>(import('../pages/version.vue'));//向导页
const Flow =()=>(import('../pages/flow/index.vue'));
// const Step6=()=>(import ('../components/step/step_6new.vue'))
const Step6=()=>(import ('../pages/step_6new.vue'))
const Taskset =()=>(import('../pages/tasksetting.vue'))//参数设置页面
const KM=()=>(import('../pages/monitor/index.vue'));//监控台
const Account={
	template:`<div><router-view></router-view></div>`
}
const routes = [
	{
		path: '/',
		component: Main,
		name: 'Symphony',
		meta:{header:true,footer:true,activeType:'job'}
	},
	{
		path: '/account',
		component:Account,
		children:[
			{
				path:'login',
				component: Login,
				name: '登录'
			},
			{
				path: 'signupActivate',
				component: ActivationAccount,
				name: '激活账号'
			},
			{
				path: 'forgetPwd',
				component: ForgetPwd,
				name: '忘记密码'
			},

			{
				path: 'resetPwd',
				component: ResetPwd,
				name: '重置密码'
			}
		]

	},
  { 
    path: '/Flow/:id',
    component: Flow,
    name: 'flow',
    meta: {heightAuto: true}
	},
	{
		path:'/monitor',
			component:KM,
			meta:{header:true,footer:true,activeType:'monitor'},
			name:'监控台'
	},
	{
			path:'/deploy/:id',
			component:Step6,
			meta:{header:true,footer:false},
			name:'部署'
	},
	
	/*{
		path: '/signup',
		component: Signup,
		name: '注册'
	},*/
	{
		path: '/commissionCalculate/:id',
		component: Step,
		name: '向导',
		meta:{header:true},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				console.log(vm.data)
			})
		}
	},
  {
    path: '/version/:id',
    component: Version,
    name: '版本列表',
    meta:{header:true},
  },
  {
	path:'/taskset',
	component:Taskset,
	name:'任务设置',
	meta:{header:true}
  },
	{
    path: '/denyAccess',
	component: DenyAccess,
	meta:{header:true,footer:true},
    name: '没有访问权限'
  },
  {
    path: '*',
    component: NotFound,
    name: '未找到相关页面'
  }
]
const router=new VueRouter({
	routes
})

router.afterEach((to, from, next) => {
//	console.log(to)
	document.title = to.name
})
export default  router



// WEBPACK FOOTER //
// ./src/router/index.js